// Modos de tarifa; deben coincidir con BoleteraService::MODO_*
export const MODO_FIJA = 1;
export const MODO_DISTANCIA = 2;

export const money = (v) =>
  (Number(v) || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN" });

/*
  Precio de un tipo de tarifa para el destino elegido.

  En modo fijo el precio viene en el catálogo. En modo distancia depende del par
  origen→destino, así que sale de la reja `precios` de la zona destino. Devuelve null
  cuando no hay tarifa configurada: ese tipo no se puede vender y la UI lo deshabilita.
*/
export const precioDe = (catalogo, zonaDestino, tipo, zonaOrigenId) => {
  if (!catalogo) return null;

  if (catalogo.modo === MODO_DISTANCIA) {
    if (!zonaDestino || !zonaOrigenId) return null;
    const porOrigen = zonaDestino.precios?.[zonaOrigenId];
    const precio = porOrigen?.[tipo.id];
    return precio == null ? null : Number(precio);
  }

  return tipo.precio == null ? null : Number(tipo.precio);
};

export const lineasDelCarrito = (catalogo, zonaDestino, qty, zonaOrigenId) =>
  (catalogo?.tipos ?? [])
    .map((tipo) => {
      const cantidad = qty[tipo.id] ?? 0;
      const precio = precioDe(catalogo, zonaDestino, tipo, zonaOrigenId);
      return cantidad > 0 && precio != null
        ? { tipo, cantidad, precio, subtotal: cantidad * precio }
        : null;
    })
    .filter(Boolean);

export const totales = (lineas) => ({
  boletos: lineas.reduce((a, l) => a + l.cantidad, 0),
  total: lineas.reduce((a, l) => a + l.subtotal, 0),
});

// Una zona es vendible si al menos un tipo tiene precio para el origen elegido
export const zonaVendible = (catalogo, zona, zonaOrigenId) =>
  (catalogo?.tipos ?? []).some((t) => precioDe(catalogo, zona, t, zonaOrigenId) != null);

export const nuevoUuid = () =>
  (window.crypto?.randomUUID?.() ??
    `u-${Date.now()}-${Math.random().toString(16).slice(2)}`);
